import './App.css'

import { ToasterComponent } from './features/toaster/ui/ToasterComponent'
import Chicken from './components/Chicken'
import PixelScripts from './components/PixelScripts'

function App() {
    return (
        <div>
            <PixelScripts/>
            <Chicken />
            <div id="modals" />
            <ToasterComponent />
        </div>
    )
}

export default App
